import React, {useEffect, useState} from 'react';
import AuthService from "../../../Services/auth/authAPI";
import StationAPI from "../../../apis/stationApi/StationAPI";
import {toast} from "react-toastify";

const StationDashboard = () => {

    const [loading, setLoading] = useState(true);
    const [setting, setSetting] = useState([]);
    const [me, setMe] = useState(AuthService.getAuthenticatedUser());

    const fetchSetting = async () => {
        try{
            const data =  await StationAPI.findSetting();
            setSetting(data);
            setLoading(false);
        }catch(error){
            toast.error("Erreur lors du chargement des paramettres !");
        }
    };



    useEffect(() => {
        fetchSetting();
        return () => console.log("...");
    },[]);

    let counter = 1;

    return (
        <div className="container mt-2">
            <div className="row justify-content-center">
                <div className="col-md-12">
                    <div className="card p-2">
                        <div className="card-body justify-content-center">
                            <h3>Bonjour, <b>{me ? (<>{me.user.name}</>):(<></>)}</b></h3>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default StationDashboard;